const AccountApi = {
  GET_ACCOUNT: '/account',
  UPDATE_DRIVER: '/driver/update',
};
export default AccountApi;
